import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowUpSvg = (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 1V14" stroke="currentColor"/>
        <path d="M0.5 6.5L6 1L11.5 6.5" stroke="currentColor"/>
    </svg>
)

const ArrowUp: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowUpSvg}
    </SvgIcon>
)

export default ArrowUp